module.exports = __webpack_public_path__ + "img/job-professional.876c41aa.svg";